'use strict';

class MainController {
  constructor($timeout,
              $interval,
              $cookies,
              $rootScope,
              $scope,
              $filter,
              $state,
              $translate,
              $q,
              AuthService,
              utils,
              config,
              OrganizationService,
              IdleService,
              $log,
              UsersService,
              I18nService,
              PermissionsService,
              ClipboardService,
              ToastsService,
              ReportsService,
              OfflineService) {

    const $t = $filter('translate');
    const CURRENT_ADMIN_LOCAL_STORAGE_KEY = 'App-Admin';
    const SELECTED_MENU_LOCAL_STORAGE_KEY = 'App-Menu';
    const ORGANIZATIONS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const LAST_USED_LOGO_LOCAL_STORAGE_KEY = 'Org-Logo';
    const ORG_COLORS_LOCAL_STORAGE_KEY = 'Org-Colors';

    $scope.selectedActiveMenu = 'organizations';
    $scope.mainPage = {};
    $scope.orderOrg = ['name', 'domainName'];
    $scope.selectedLng = I18nService.getLocale();

    let $mainPage = $scope.mainPage;

    // #region Menu Items
    $scope.menus = {
      'dashboard': {
        name: 'dashboard',
        iconClassName: 'far fa-chart-bar',
        desc: 'menu.dashboard',
        uiSref: 'main.dashboard.panel',
        display: false
      },
      'organizations': {
        name: 'organizations',
        iconClassName: 'far fa-sitemap',
        desc: 'menu.organizations',
        uiSref: 'main.organizations.list',
        display: false
      },
      'notifications': {
        name: 'notifications',
        feature: 'n',
        iconClassName: 'far fa-bell',
        desc: 'menu.notifications',
        uiSref: 'main.notifications.list',
        display: false
      },
      'users': {
        name: 'users',
        iconClassName: 'iotr fa-friends',
        desc: 'menu.users',
        uiSref: 'main.users.list',
        display: true
      },
      'locations': {
        name: 'locations',
        iconClassName: 'far fa-map',
        desc: 'menu.locations',
        uiSref: 'main.locations.list',
        display: true
      },
      'devices': {
        name: 'devices',
        iconClassName: 'iotr fa-gateway',
        desc: 'menu.devices',
        uiSref: 'main.devices.list',
        display: true
      },
      'groups': {
        name: 'groups',
        iconClassName: 'far fa-paperclip',
        desc: 'menu.groups',
        uiSref: 'main.groups.list',
        display: false
      },
      'bots': {
        name: 'bots',
        iconClassName: 'iotr fa-bot',
        desc: 'menu.bots',
        uiSref: 'main.bots.list',
        display: false,
      },
      'challenges': {
        name: 'challenges',
        feature: 'c',
        iconClassName: 'far fa-bolt',
        desc: 'menu.challenges',
        uiSref: 'main.challenges.list',
        display: false
      },
      'billing': {
        name: 'billing',
        iconClassName: 'far fa-wallet',
        desc: 'menu.billing',
        uiSref: 'main.billing.list',
        display: false
      },
      'reports': {
        name: 'reports',
        iconClassName: 'far fa-chart-line',
        desc: 'menu.reports',
        uiSref: 'main.reports.list',
        display: false
      },
      'website': {
        name: 'website',
        feature: 'w',
        iconClassName: 'far fa-globe',
        desc: 'menu.website',
        linkProp: 'websiteDirectUrl',
        display: false
      },
      'profile': {
        name: 'profile',
        iconClassName: 'iotr fa-user-admin',
        desc: 'menu.profile',
        uiSref: 'main.profile',
        display: false
      },
    };
    // #endregion

    // #region Watchers

    $rootScope.$on('refreshMenusEvent', function(event) {
      $scope.selectedOrg = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    });

    $scope.$watch('selectedOrg', (newValue, oldValue) => {
      if (!$scope.selectedOrg) {
        const savedLogo = utils.getStorageItem(LAST_USED_LOGO_LOCAL_STORAGE_KEY);
        if (savedLogo) {
          $scope.orgLogoUrl = savedLogo;
        } else {
          $scope.orgLogoUrl = undefined;
        }
        return;
      }
      utils.getOrganizationLogoPath($scope.selectedOrg.id)
        .then(logoPath => {
          $scope.orgLogoUrl = logoPath;
          utils.setStorageItem(LAST_USED_LOGO_LOCAL_STORAGE_KEY, logoPath);
        });
    });

    $scope.$watchGroup(['userInfo', 'selectedOrg'], (newValue, oldValue) => {
      if (!$scope.userInfo || !$scope.selectedOrg) {
        return;
      }

      // Show or hide organization modules
      $scope.menus.organizations.display = PermissionsService.canIViewOrganizationList();
      $scope.menus.notifications.display = showModule('n') && PermissionsService.canIViewNotificationList();
      $scope.menus.users.display = PermissionsService.canIViewUserList();
      $scope.menus.locations.display = PermissionsService.canIViewLocationList();
      $scope.menus.devices.display = PermissionsService.canIViewDeviceList();
      $scope.menus.groups.display = showModule('g') && PermissionsService.canIViewGroupList();
      $scope.menus.challenges.display = showModule('c') && PermissionsService.canIViewChallengeList();
      $scope.menus.bots.display = showModule('b') && PermissionsService.canIManageBots();
      $scope.menus.website.display = showModule('w');
      $scope.menus.billing.display = PermissionsService.canIConfigureBilling();

      // Show or hide dashboard and reports
      testAvailableReports()
        .then(data => {
          $scope.menus.dashboard.display = PermissionsService.canIViewDashboard() && data.isAnalyticReports;
          $scope.menus.reports.display = PermissionsService.canIUseGlobalReports() || (data.isLocalReports && PermissionsService.canIViewReportList());
        });
    });

    $scope.$watchGroup(['finishGetOrganizations', 'userInfo'], () => {
      if ($scope.userInfo && $scope.finishGetOrganizations) {
        if ($scope.menus.organizations.display) {
          // Redirect admins with editing permissions to organizations module
          if (PermissionsService.canICreateOrganization() && (!$scope.organizations || $scope.organizations.length === 0)) {
            return gotoOrganizationModule();
          }
        } else if (!$scope.selectedActiveMenu || $scope.selectedActiveMenu === 'organizations') {
          // If organizations module turned off
          goAndRefreshState('main.users.list');
          refreshChooseMenu('users');
        }
      }
    });

    $rootScope.$on('showChooseOrganizationsDialogEvent', function($event) {
      $event.stopPropagation();
      $scope.popupChangeOrgDialog();
    });

    $rootScope.$on('chooseOrganizationEvent', function($event, org, menuName) {
      $event.stopPropagation();
      $scope.chooseOrg(org, menuName || 'organizations');
      if (org) {
        subscribeForNarratives(org);
      }
    });

    initOfflineWatching();

    // #endregion

    function initPage() {
      let orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
      if (orgInfo) {
        $scope.selectedOrg = orgInfo;
        $scope.selectedActiveMenu = utils.getStorageItem(SELECTED_MENU_LOCAL_STORAGE_KEY);
        subscribeForNarratives(orgInfo.id);
      }

      const savedOrgColors = utils.getStorageItem(ORG_COLORS_LOCAL_STORAGE_KEY);
      const defaultColorScheme = config.getConfigByKey('orgColors');
      utils.updateOrgCssFile(savedOrgColors || defaultColorScheme);

      $('#maestro-orgs-modal').modal({
        closable: false,
        detachable: false,
        onApprove: function() {

        },
        onShow: function() {
          $scope.searchOrgVal = $scope.searchOrgValBak ? $scope.searchOrgValBak : '';
        },
        onHidden: function() {
          $scope.$apply(function() {
            $scope.searchOrgValBak = $scope.searchOrgVal;
            $scope.searchOrgVal = '';
          });
        }
      });

      // Change Header Class on page scroll (deprecated)
      /*$('#maestro-page').visibility({
        offset: 60.59375,
        once: false,
        onTopPassed: function(calculations) {
          $('#maestro-header, #maestro-divider, #maestro-left-menu').addClass('min');
        },
        onTopPassedReverse: function(calculations) {
          $('#maestro-header, #maestro-divider, #maestro-left-menu').removeClass('min');
        }
      });*/

      $('#dropdown-avatar').dropdown({
        on: 'hover'
      });

      $('.ui.accordion').accordion();

      $('#maestro-avatar').dimmer({
        on: 'hover'
      });

      // When mobile sidebar opened
      $('#maestro-sidebar').sidebar({
        silent: true, // Disable annoying SUI error
        exclusive: true
      });

      // Get User Info
      getUserInfo();

      // Start the resizing watcher
      resizeFun();

      /**
       * Get Organizations
       */
      $mainPage.getOrganizations()
        .then(data => {
          $scope.cookieMenuName = $cookies.get($scope.userInfo.user.id + '::' + 'selected-menuName');
          $scope.cookieOrgId = $cookies.get($scope.userInfo.user.id + '::' + 'selected-orgId');

          if (!data || !data.organizations || data.organizations.length === 0) {
            $scope.finishGetOrganizations = true;
            return;
          }

          let selectedOrg;
          // Try to select Organization from Cookies
          if ($scope.cookieOrgId) {
            selectedOrg = data.organizations.find(el => {
              return (el.organizationEditor || el.organizationAdmin || el.parentAdmin) && el.id === parseInt($scope.cookieOrgId);
            });
          }
          // Try to select first available Organization
          if (!selectedOrg) {
            selectedOrg = data.organizations.find(el => el.organizationEditor || el.organizationAdmin || el.parentAdmin);
            if (!selectedOrg && PermissionsService.isUnlimitedAdmin()) {
              selectedOrg = data.organizations[0];
            }
          }
          // This will return some general error
          if (!selectedOrg) {
            $scope.finishGetOrganizations = true;
            return;
          }

          $scope.chooseOrg(selectedOrg, $scope.cookieMenuName || null, true);
        });

      initIdleTimer();
    }

    /**
     * Check organization feature
     * @param {string} m Module aka feature
     * @returns {boolean}
     */
    function showModule(m) {
      if (!m || !$scope.selectedOrg || !$scope.selectedOrg.features) {
        return false;
      }
      let features = $scope.selectedOrg.features;
      return features.indexOf(m) !== -1;
    }

    /**
     * Get user information for current admin
     */
    function getUserInfo() {
      $scope.userInfo = utils.getStorageItem(CURRENT_ADMIN_LOCAL_STORAGE_KEY);
      let sidebarState = $cookies.get($scope.userInfo.user.id + '::' + 'selected-miniSidebar');
      $scope.miniSidebar = sidebarState == 1 ? true : false;
      $rootScope.miniSidebar = $scope.miniSidebar;

      // Set User language
      if ($scope.userInfo.user.language !== $scope.selectedLng.code) {
        updateUserInfo({
          'language': $scope.selectedLng.code
        })
          .then(function() {
            $scope.userInfo.user.language = $scope.selectedLng.code;
            utils.setStorageItem(CURRENT_ADMIN_LOCAL_STORAGE_KEY, $scope.userInfo);
          });
      }
    }

    function updateUserInfo(updateUserModel) {
      return UsersService.updateUserInfo(updateUserModel)
        .then((data) => {
          utils.setStorageItem(CURRENT_ADMIN_LOCAL_STORAGE_KEY, $scope.userInfo);
          return data;
        });
    }

    function refreshChooseMenu(menuName) {
      $scope.selectedActiveMenu = menuName;
      utils.setStorageItem(SELECTED_MENU_LOCAL_STORAGE_KEY, menuName);
      $cookies.put($scope.userInfo.user.id + '::' + 'selected-menuName', menuName, {
        'expires': utils.getCookieExpires(),
        'samesite': 'strict'
      });
    }

    /**
     * Resize left menu sidebar
     */
    function resizeFun() {
      checkMobileViewToggle();

      $(window).on('resize', function() {
        checkMobileViewToggle();
        // Hide sidebar when resizing window while sidebar opened
        if ($('#maestro-sidebar').sidebar('is visible') && $('#maestro-left-menu').is(':visible')) {
          $('#maestro-sidebar').sidebar('hide');
        }

      });
    }

    /**
     * Test for mobile viewport
     */
    function checkMobileViewToggle() {
      let isDisplayView = $('#maestro-left-menu').is(':visible');
      if ($rootScope.isMobileView === !isDisplayView) {
        return;
      }
      $rootScope.$applyAsync(function() {
        $rootScope.isMobileView = !isDisplayView;
      });
    }

    /**
     * Get Organization Properties.
     * @param {number} orgId Orgnization ID
     * @returns {Promise}
     */
    function getOrgProperties(orgId) {
      return OrganizationService.getObjectsAndProperties(orgId);
    }

    /* Redirects to Organization Module */
    function gotoOrganizationModule() {
      goAndRefreshState('main.organizations.list');
      refreshChooseMenu('organizations');
    }

    $scope.popupChangeOrgDialog = function() {
      $scope.organizations = [];
      $mainPage.getOrganizations()
        .then(function(data) {
          $scope.organizations = (data && data.organizations) ? data.organizations : [];
          $timeout(function() {
            $scope.modal('maestro-orgs-modal', 'show');
          }, 200);
        });
    };

    $scope.toggleSidebar = function() {
      $('#maestro-sidebar').sidebar('toggle');
    };

    $scope.toggleMinSidebar = function() {
      $scope.$applyAsync(() => {
        $scope.miniSidebar = $scope.miniSidebar ? false : true;
        $rootScope.miniSidebar = $scope.miniSidebar;

        // Save to Cookies
        let cookieSidebar = $scope.miniSidebar ? 1 : 0;
        $rootScope.miniSidebar = angular.copy($scope.miniSidebar);
        $cookies.put($scope.userInfo.user.id + '::' + 'selected-miniSidebar', cookieSidebar, {
          'expires': utils.getCookieExpires(),
          'samesite': 'strict'
        });
      });
    };

    $scope.modal = function(id, behavior) {
      // Set the Modal settings
      let settings = {
        detachable: true,
        closable: false
      };
      $('#' + id).modal(settings).modal(behavior);
    };

    $scope.signout = function() {
      return AuthService.logoutFromAllBrowsers()
        .then(() => {
          utils.clearCache();
          window.location.href = '/';
        }, (err) => {
          $log.error('Error while logging out from all browsers');
          $log.error(err);
          AuthService.logoutFromThisBrowser();
          utils.clearCache();
          window.location.href = '/';
        });
    };

    $scope.goToUserProfile = function() {
      $state.go('main.profile');
    };

    $rootScope.hideErrorMsg = function() {
      $rootScope.errorMessages = {};
    };

    $scope.chooseMenu = function(event, menu) {
      let menuName = menu.name;
      if (!menu.uiSref) {
        if (menu.linkProp) {
          getOrgProperties($scope.selectedOrg.id)
            .then(data => {
              if (data.organizationObjects && data.organizationObjects.length > 0) {
                let urlObj = data.organizationObjects.find(el => el.name === menu.linkProp);
                if (urlObj && urlObj.value) {
                  window.open(urlObj.value, '_blank');
                }
              }
            });
        }
        menuName = $scope.selectedActiveMenu;
      } else {
        $state.go(menu.uiSref);
      }
      refreshChooseMenu(menuName);
    };

    $rootScope.$on('refreshChooseMenuEvent', function(event, menuName) {
      refreshChooseMenu(menuName);
    });

    $rootScope.$on('refreshStateMenuEvent', function(event, toState) {
      for (let menu in $scope.menus) {
        if ($state.includes('main.' + menu)) {
          refreshChooseMenu(menu);
        }
      }
    });

    $rootScope.$on('$stateChangeSuccess', function(ev, to, toParams, from, fromParams) {
      $rootScope.fromPage = from.name;
      $rootScope.fromPageParams = fromParams;

      // Restart the window size watcher
      resizeFun();
    });

    $mainPage.getOrganizations = function() {
      $scope.finishGetOrganizations = false;
      return OrganizationService.getOrganizations()
        .then((data) => {
          const orgs = angular.copy(data?.organizations || []);
          utils.setStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY, orgs);

          if (orgs && orgs.length > 0) {
            $scope.organizations = orgs;
            if (orgs.length > 1) {
              $scope.menus.organizations.display = true;
            }
          } else if (PermissionsService.isReportOnlyAdmin()) {
            $scope.organizations = [];
            initReportsOnly();
          } else {
            $scope.organizations = [];
            showTipAndSignout();
          }
          return data;
        }, (err) => {
          $scope.finishGetOrganizations = true;
          $scope.organizations = [];

          if (PermissionsService.isReportOnlyAdmin()) {
            initReportsOnly();
            return;
          }

          showTipAndSignout();
          return $q.reject(err);
        });
    };

    function initReportsOnly() {
      $scope.organizations = [];
      utils.removeStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY);
      utils.removeStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);

      Object.values($scope.menus)
        .forEach(menu => menu.display = false);
      $scope.menus.reports.display = true;

      goAndRefreshState('main.reports.list');
      refreshChooseMenu('reports');
    }

    /**
     * Shows a modal dialog to the user informing about the reason why user is not allowed to navigate
     * further into dashboard with a button to sign-out immediately and time which will sign user out automatically.
     */
    function showTipAndSignout() {
      let seconds = 10;

      $('#non-admin-modal')
        .modal({
          closable: false,
          detachable: true
        })
        .modal('show');

      // Update label once per second
      let intervalP = $interval(function() {
        seconds--;
        if (seconds === 0) {
          $interval.cancel(intervalP);
          return;
        }
        $('#non-admin-warning-timer').html($t('common.none-admin-warning-timer', { val: seconds }));
      }, 1000);

      // Sign out automatically after 10 seconds.
      $timeout(function() {
        seconds = 0;
        $scope.signout();
      }, 10000);
    }

    $scope.chooseOrg = function(org, menuName, initial) {
      return getOrgProperties(org.id)
        .then(data => {
          if (data.resultCode !== 0) {
            return;
          }

          $scope.selectedOrg = org;
          utils.setStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY, org);
          $scope.modal('maestro-orgs-modal', 'hide');
          $cookies.put($scope.userInfo.user.id + '::' + 'selected-orgId', org.id, {
            'expires': utils.getCookieExpires(),
            'samesite': 'strict'
          });

          const defaultColorScheme = config.getConfigByKey('orgColors');
          if (data.organizationObjects) {
            utils.setStorageItem(ORG_COLORS_LOCAL_STORAGE_KEY, data.organizationObjects);
          }
          utils.updateOrgCssFile(data.organizationObjects || defaultColorScheme);

          subscribeForNarratives($scope.selectedOrg);

          if (menuName) {
            $scope.selectedActiveMenu = menuName;
            utils.setStorageItem(SELECTED_MENU_LOCAL_STORAGE_KEY, $scope.selectedActiveMenu);
            let menu = $scope.menus[menuName];
            let flag = !!menu && !!menu.display && (!menu.feature || showModule(menu.feature));
            if ($state.includes('main.' + menuName + '.**')) {
              // Not go any new state
            } else {
              if (flag && menu.uiSref) {
                goAndRefreshState(menu.uiSref);
              } else {
                $scope.selectedActiveMenu = 'users';
                goAndRefreshState('main.users.list');
              }
            }
          } else if ($scope.selectedActiveMenu === 'organizations') {
            gotoOrganizationModule();
          } else {
            $scope.selectedActiveMenu = 'locations';
            goAndRefreshState('main.locations.list');
          }
        })
        .then(() => {
          if (initial) {
            $scope.finishGetOrganizations = true;
          }
        });
    };

    function goAndRefreshState(stateName) {
      $state.go(stateName, null, { reload: stateName });
    }

    // #region Idle Dialog

    let idleTimerInterval;

    function initIdleTimer() {
      let logoutOnIdle = !!config.getConfigByKey('environment.logoutOnIdle');
      if (!logoutOnIdle) {
        return;
      }

      let unsubscribeFunc = IdleService.onIdle((overdueTimeMs) => {
        showIdleWarningDialog(overdueTimeMs);
      });

      $scope.$on('$destroy', function() {
        if (idleTimerInterval) {
          $interval.cancel(idleTimerInterval);
        }
        if (unsubscribeFunc) {
          unsubscribeFunc();
        }
      });
    }

    /**
     * Shows a modal dialog to the user informing about the reason why user is not allowed to navigate
     * further into dashboard with a button to sign-out immediately and time which will sign user out automatically.
     */
    function showIdleWarningDialog(overdueTimeMs) {
      if (idleTimerInterval) {
        $interval.cancel(idleTimerInterval);
        $('#idle-modal').modal('hide');
      }

      if (!AuthService.isAuthenticated()) {
        return;
      }

      const countdownSeconds = 60;

      if (overdueTimeMs >= countdownSeconds * 1000) {
        $log.log('Logged out due to inactivity');
        utils.clearCache();
        AuthService.logoutFromThisBrowser();
        $rootScope.errorMsg = $t('common.idle-logout-message');
        $state.go('signin');
        return;
      }

      $('#idle-modal')
        .modal({
          blurring: true,
          closable: false,
          detachable: true
        })
        .modal('show');

      $('#idle-warning-timer').html($t('common.idle-warning-timer', { val: countdownSeconds }));
      let seconds = countdownSeconds;
      // Update label once per second
      const idleTimerStartMs = new Date().getTime();
      idleTimerInterval = $interval(() => {
        seconds = Math.ceil(countdownSeconds - (new Date().getTime() - idleTimerStartMs) / 1000);
        if (seconds <= 0) {
          seconds = 0;
          $interval.cancel(idleTimerInterval);
          $('#idle-modal').modal('hide');
          $log.log('Logged out due to inactivity');
          utils.clearCache();
          AuthService.logoutFromThisBrowser();
          $rootScope.errorMsg = $t('common.idle-logout-message');
          $state.go('signin');
          return;
        }
        $('#idle-warning-timer').html($t('common.idle-warning-timer', { val: seconds }));
      }, 1000);
    }

    $scope.forceIdleLogout = function() {
      if (idleTimerInterval) {
        $interval.cancel(idleTimerInterval);
      }
      $('#idle-modal').modal('hide');
      utils.clearCache();
      AuthService.logoutFromThisBrowser();
      window.location.href = '/';
    };

    $scope.cancelIdle = function() {
      if (idleTimerInterval) {
        $interval.cancel(idleTimerInterval);
      }
      $('#idle-modal').modal('hide');
    };

    // #endregion

    /**
     * Copy text to clipboard
     * @param {string} text
     * @param {event} $event
     * @return {Promise}
     */
    $rootScope.copyToClipboard = function(text, $event) {
      $event && $event.stopPropagation();
      ClipboardService.copyText(text)
        .then(() => {
          ToastsService.success(null, $t('common.copyToClipboardSuccess'));
        }, () => {
          ToastsService.error(null, $t('common.copyToClipboardFailure'));
        });
    };

    // #region Notification Subscription

    let narrativesSubscription;
    let prevOrgId;

    $scope.$on('$destroy', function() {
      narrativesSubscription?.unsubscribe();
    });

    function subscribeForNarratives(organization) {
      if (!organization || !organization.id || organization.id === prevOrgId) {
        return;
      }
      prevOrgId = organization.id;

      if (narrativesSubscription) {
        narrativesSubscription.unsubscribe();
        narrativesSubscription = undefined;
      }

      if (!utils.hasFeature(organization, 'n')) {
        return;
      }

      narrativesSubscription = OrganizationService.subscribeForOrganizationNarratives(organization.id, {});

      narrativesSubscription.onCreate((data) => {
        $scope.$applyAsync(() => {
          if (data?.narrative) {
            showNarrativeToast(data?.narrative);
          }
        });
      });
      narrativesSubscription.onError((data) => {

        // Similar subscription exists
        if (data?.resultCode === 26) {
          return;
        }

        $log.warn('Narrative subscription error:');
        $log.warn(data);
      });
      narrativesSubscription.onStatusChange((data) => {
        // $log.log('Narrative subscription status changed: ' + data);
      });
    }

    function showNarrativeToast(narrative) {
      const narrativePriorities = config.getConfigByKey('narrativePriorities');
      const narrativeTypes = config.getConfigByKey('narrativeTypes');
      const priorityConfig = narrativePriorities.find(el => el.id == narrative.priority);

      let narrativeTitle = narrative.title;
      if (!narrativeTitle) {
        const narrativeType = narrativeTypes.find(type => narrative.narrativeType === type.id);
        narrativeTitle = narrativeType ? $t(narrativeType.desc) : $t('events.types.unknown');
      }

      ToastsService.custom({
        message: narrativeTitle,
        className: `${priorityConfig.toastClass} compact clickable`,
        timeout: 20000,
        icon: 'fal fa-bell',
        onClick: () => {
          // Goto narratives page or drop filter if we are already there
          if (!$state.includes('main.notifications.list')) {
            $state.go('main.notifications.list', null, { highlight: narrative.id });
          } else {
            // Raise event
            $scope.$broadcast('highlightNarrative', { highlight: narrative.id });
          }
        }
      });
    }

    // #endregion

    /**
     * Get and test Report Groups for current Organization
     * Determine if 'reports' and 'dashboard' menus is available
     */
    function testAvailableReports() {
      let result = {
        isLocalReports: false,
        isAnalyticReports: false
      };

      return ReportsService.getReportGroups($scope.selectedOrg.id)
        .then(data => {
          if (data && data.groups && data.groups.length) {
            result.isAnalyticReports = data.groups.some(g => g.analytic && !!g.organizationId);
            result.isLocalReports = data.groups.some(g => !g.analytic && !!g.organizationId);
          }
          return result;
        }, err => {
          return result;
        });
    }

    //region Offline mode

    function initOfflineWatching() {
      let onConnectedUnsubscribe;
      let onDisconnectedUnsubscribe;

      $('#offline-modal')
        .modal({
          closable: false,
          detachable: true
        });

      onConnectedUnsubscribe = OfflineService.onConnected(() => {
        $('#offline-modal').modal('hide');
      });

      onDisconnectedUnsubscribe = OfflineService.onDisconnected(() => {
        $('#offline-modal').modal('show');
      });

      if (OfflineService.isDisconnected()) {
        $('#offline-modal').modal('show');
      }

      $scope.$on('$destroy', function() {
        if (onConnectedUnsubscribe) {
          onConnectedUnsubscribe();
        }
        if (onDisconnectedUnsubscribe) {
          onDisconnectedUnsubscribe();
        }
      });
    }

    //endregion

    initPage();

  }
}

export default angular
  .module('main.controller', [
    'ngCookies'
  ])
  .controller('MainController', MainController)
  .name;
